import React from "react";
import classnames from "classnames";
import ico_arrow_left from "../assets/icons/ico_arrow_left.svg";
import ico_arrow_right from "../assets/icons/ico_arrow_right.svg";
const GoToPage = (props) => {
  const { page, side, name, target } = props;
  const textStyles = classnames(
    props.textColor,
    props.fontSizeXL,
    props.fontSizeL,
    props.fontSizeM,
    props.fontSizeS,
    props.fontSize,
    props.textType,
    props.borderType,
    props.borderColor
  );
  const iconStyles = classnames(
    props.iconSizeXL,
    props.iconSizeL,
    props.iconSizeM,
    props.iconSizeS,
    props.iconSize,
    props.iconColor,
    props.iconMargin
  );
  return (
    <div className="w-fit h-fit z-50">
      
        {side == "right" ? (
          <div className={textStyles}>
          <a href={page} target={target || ""} className="items-center inline-flex">
            {name}
            <img loading="lazy" className={iconStyles} src={ico_arrow_right}></img>
          </a>
          </div>
        ) : (
          <div className={textStyles}>
          <a href={page} target={target || ""} className="items-center inline-flex">
            <img loading="lazy" className={iconStyles} src={ico_arrow_left}></img>
            {name}
          </a>
          </div>
        )}
      </div>
  );
};

export default GoToPage;
